import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authApi } from '../api/authApi';

export default function RestorePasswordPage() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);

    try {
      const response = await authApi.restorePassword(email);
      if (response.success) {
        navigate('/login', { 
          state: { 
            message: 'Инструкции по восстановлению пароля отправлены на ваш email.' 
          } 
        });
      } else {
        setError(response.message || 'Ошибка при восстановлении пароля');
      }
    } catch (err) {
      setError('Произошла ошибка при восстановлении пароля');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <article className="mx-auto h-[calc(100vh-190px)] flex items-center justify-center w-0 flex-1 flex-col gap-6 py-10">
      <div className="max-w-md w-full space-y-8 p-8 bg-white rounded-xl shadow">
        <div>
          <p className="mt-6 text-center text-base font-light text-gray-600">
            Восстановление пароля <span className="font-medium">parallel.one</span>
          </p>
        </div>
        <form className="mt-6 space-y-6" onSubmit={handleSubmit}>
          {error && (
            <div className="mb-6 text-red-500 text-sm text-center">{error}</div>
          )}
          <div className="shadow-sm -space-y-px">
            <div>
              <label htmlFor="email" className="sr-only">
                Электронная почта
              </label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                className="appearance-none rounded-3xl relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-gray-500 focus:border-gray-500 focus:z-10 sm:text-sm"
                placeholder="Электронная почта"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>

          <div>
            <button
              type="submit"
              disabled={isSubmitting}
              className="mb-8 group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-3xl text-white bg-gray-600 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
            >
              {isSubmitting ? 'Отправка...' : 'Восстановить пароль'}
            </button>
            <p className="text-center text-base font-light font-light text-gray-600">
                <a className="font-medium text-gray-600 hover:underline" href="/login">Вернуться на страницу входа</a>
            </p>
          </div>
        </form>
      </div>
    </article>
  );
} 